<template>
  <!--商城交易佣金分配比例-->
  <el-dialog
          title="员工锁粉设置"
          :visible.sync="dialogVisible"
          @close="$emit('update:visible',false)"
          width="420px"
  >
    <div class="dialog_conwrap dialog_auth lockguest">
      <!--<p>-->
      <!--<label>名片主-->
      <!--<el-input-number-->
      <!--class="w160"-->
      <!--v-model="numUser"-->
      <!--controls-position="right"-->
      <!--@change="handleChange"-->
      <!--:min="0"-->
      <!--:max="100"-->
      <!--step="1"-->
      <!--&gt;</el-input-number></label>,-->
      <!--<label>专属顾问-->
      <!--<el-input-number-->
      <!--class="w160"-->
      <!--v-model="numAdviser"-->
      <!--controls-position="right"-->
      <!--@change="handleChange"-->
      <!--:min="0"-->
      <!--:max="100"-->
      <!--step="1"-->
      <!--&gt;</el-input-number></label>-->
      <!--</p>-->
      <!--<p class="descLine">当客户没有专属顾问时，佣金默认100%分配给交易完成的名片主；如专属顾问名片及AI雷达被关闭，则该专属顾问不可获得佣金，佣金将100% 分配给交易完成的名片主。</p>-->
      <p class="descLine">确认开启员工锁粉?<span>锁粉后将不能关闭.</span></p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" @click="submitApply">确认开启</el-button>
    </span>
  </el-dialog>
</template>
<script>
  import api from "@/api.js";
  export default {
    name: "lockguestDialog",
    props: ["visible"],
    watch: {
      visible() {
        this.dialogVisible = this.visible;
      }
    },
    data() {
      return {
        numUser: 0,
        numAdviser: 0,
        dialogVisible: this.visible
      };
    },
    methods: {
      handleChange(value) {
      },
      submitApply() {
        this.axios
            .post(api.fans_open, {})
            .then(response => {
              if (response.data.code == 0) {
                this.$emit('initPage')
                this.dialogVisible = false
              } else {
              }
            })
            .catch(response => {
            });

      }
    }
  };
</script>
